import { createReducer } from 'typesafe-actions';

import { IThemeState, TThemeAction, ThemeActionTypes } from '@/store/types/theme.types';

const initialState: IThemeState = {
  currentTheme: 0,
};

export const themeReducer = createReducer<IThemeState, TThemeAction>(initialState).handleType(
  ThemeActionTypes.SET_THEME,
  (state, action) => ({
    ...state,
    currentTheme: action.currentTheme,
  }),
);
